import { render, staticRenderFns } from "./presellType.vue?vue&type=template&id=c2ac388a&scoped=true"
import script from "./presellType.vue?vue&type=script&lang=js"
export * from "./presellType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ac388a",
  null
  
)

export default component.exports